import React from "react";
import { Scale, Users, Leaf } from "lucide-react";
import "../../styles/About/About.css";
import founder from "./founder.jpg";

const AboutUs = () => {
  return (
    <div id="about" className="about-container">
      <div className="about-content">
        <header className="about-header">
          <h2 className="about-title">About Us</h2>
          <div className="title-underline"></div>
        </header>

        <section className="founder-section">
          <div className="founder-content">
            <div className="founder-text">
              <h3 className="section-title">Founder's Story</h3>
              <p className="founder-description">
                Phabyeon Burgess-Yearwood established this foundation with a
                vision to transform communities through education and
                collaboration. With a deep passion for empowering individuals
                and fostering sustainable development, Phabyeon has dedicated
                his life to creating opportunities for those who need them most.
              </p>
            </div>
            <div className="founder-image">
              <div className="image-placeholder">
                <img
                  style={{
                    width: "360px",
                    height: "390px",
                    borderRadius: "10px",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
                    border: "3px solid white",
                  }}
                  src={founder}
                  alt="Phabyéon Burgess-Yearwood, founder and leader of the Phabyéonj'n-pierre Foundation"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="vision-section">
          <h3 className="section-title">Vision & Mission</h3>
          <div className="vision-content">
            <p className="vision-text" style={{ textAlign: "center" }}>
              Our vision is to expand our impact globally, with a strategic
              focus on Canada, Barbados, the UK, and the USA over the next 5-10
              years. We aim to create a world where education and community
              collaboration drive sustainable development and equal
              opportunities for all.
            </p>
          </div>
        </section>

        <section className="values-section">
          <h3 className="section-title">Our Core Values</h3>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Scale size={32} />
              </div>
              <h4 className="value-title">Equity</h4>
              <p className="value-description">
                Ensuring fair access to opportunities for all
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Users size={32} />
              </div>
              <h4 className="value-title">Collaboration</h4>
              <p className="value-description">
                Working together to achieve greater impact
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Leaf size={32} />
              </div>
              <h4 className="value-title">Sustainability</h4>
              <p className="value-description">
                Creating lasting positive change
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
